import React from "react";
import { Button } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import "./NavbarTrungThu.css";

const NavbarTrungThu = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = (path) => {
    navigate(path);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar-trung-thu">
      <h1 className="navbar-brand">
        <Button
          className={`navbar-btn ${isActive("/admin") ? "active" : ""}`}
          type="primary"
          onClick={() => handleNavigate("/admin")}
        >
          Home
        </Button>
      </h1>
      <ul className="navbar-menu">
        <li>
          <Button
            className={`navbar-btn ${
              isActive("/dashboard-data") ? "active" : ""
            }`}
            type="primary"
            onClick={() => handleNavigate("/dashboard-data")}
          >
            Biểu đồ trung thu
          </Button>
        </li> 
        <li>
          <Button
            className={`navbar-btn ${
              isActive("/dashboardbkem") ? "active" : ""
            }`}
            type="primary"
            onClick={() => handleNavigate("/dashboardbkem")}
          >
            Biểu đồ bánh kem
          </Button>
        </li> 
        <li>
          <Button
            className={`navbar-btn ${
              isActive("/tktt") ? "active" : ""
            }`}
            type="primary"
            onClick={() => handleNavigate("/tktt")}
          >
            XNT Trung thu
          </Button>
        </li> 
        <li>
          <Button
            className={`navbar-btn ${
              isActive("/bieu-do-trung-thu") ? "active" : ""
            }`}
            type="primary"
            onClick={() => handleNavigate("/bieu-do-trung-thu")}
          >
            Biểu đồ Game
          </Button>
        </li>
        {/* 
        <li>
          <Button
            className={`navbar-btn ${isActive("/set-kpi-theo-mua") ? "active" : ""}`}
            type="primary"
            onClick={() => handleNavigate("/set-kpi-theo-mua")}
          >
            Set KPI
          </Button>
        </li>
        */}
      </ul>
    </nav>
  );
};

export default NavbarTrungThu;
